import { GenericDataDisplayGroupedItemsRecursive } from "react-migration/domains/map/components/GenericDataDisplayGroupedItemsRecursive";
import { SkeletonLoading } from "react-migration/components/SkeletonLoading";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Notification } from "react-migration/components/Notification";
import { useGeoJsonDeliverable } from "./useGeoJsonDeliverable";

type GeoJsonMetadataTablesProps = {
  signedUrl?: string;
  providerName: string;
};

export function GeoJsonMetadataTables({ signedUrl, providerName }: GeoJsonMetadataTablesProps) {
  const { geojson, isLoading, error } = useGeoJsonDeliverable(signedUrl);
  const { t, checkKey } = useTranslation();
  const postfixNoteTranslationKey = `third_party_on_demand_report_layer.${providerName}.selection_sidebar.geojson_metadata_tables.postfix`;
  const hasPostfixNote = checkKey(postfixNoteTranslationKey);

  if (isLoading) {
    return (
      <div className="relative h-[550px] w-full">
        <SkeletonLoading rows={2} gap={4} showPadding={false} />
      </div>
    );
  }

  if (error) {
    return (
      <Notification.Error
        className="w-full"
        title="An error occurred"
        message="There was an issue loading the report data."
      />
    );
  }

  if (!geojson?.metadata || !Object.keys(geojson.metadata).length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <GenericDataDisplayGroupedItemsRecursive
        data={geojson.metadata}
        outerGroupClassName="p-4 rounded-lg border border-border-action bg-white"
      />
      {hasPostfixNote && <span className="text-2xs font-normal text-black">{t(postfixNoteTranslationKey)}</span>}
    </div>
  );
}
